/**
 * Shared requisition display-config constants.
 *
 * Relocated here from `src/pages/requisitions/constants/{constants,enums}.ts`
 * so cross-feature consumers (reports, ATS filters) stop importing into the
 * requisitions page layer. The original modules re-export these for
 * within-feature callers.
 *
 * `RequisitionType` is a type-only import (erased at runtime), so the
 * back-reference to the requisitions enums creates no runtime cycle.
 */
import type { RequisitionType } from '@/pages/requisitions/constants/enums';

/** Requisition status → badge display config (id/label/color). */
export const requisitionStatusConfig = {
  draft: {
    id: 'draft',
    color: '#FAA238',
    label: 'Draft',
  },
  pending_approval: {
    id: 'pending_approval',
    label: 'Pending approval',
    color: '#CC7914',
  },
  approved: {
    id: 'approved',
    label: 'Approved',
    color: '#0B7B69',
  },
  rejected: {
    id: 'rejected',
    label: 'Not approved',
    color: '#FF4141',
  },
  created: {
    id: 'created',
    label: 'Ready to open',
    color: '#0B7B69',
  },
  open: {
    id: 'open',
    label: 'Open',
    color: '#73D017',
  },
  closed: {
    id: 'closed',
    label: 'Closed',
    color: '#C03744',
  },
  archived: {
    id: 'archived',
    label: 'Archived',
    color: '#585858',
  },
  filled: {
    id: 'filled',
    label: 'Filled',
    color: '#585858',
  },
};

/** Requisition type → display config (label/color). */
export const REQUISITION_TYPE_CONFIG: Record<
  RequisitionType,
  { label: string; color: string }
> = {
  new_hire: { label: 'New hire', color: 'blue' },
  backfill: { label: 'Backfill', color: 'purple' },
  internal: { label: 'Internal', color: 'green' },
};
